module.exports = __webpack_public_path__ + "media/images/backgrounds/background-feature-logs-57f8281799bc153bb5f8171abbc9f9bb.svg";